export const PKG_NAME = "@hpcc-js/codemirror";
export const PKG_VERSION = "2.66.5";
export const BUILD_VERSION = "2.108.11";
